export default "__VITE_ASSET__B2Vipmt4__";